import { createValidator, maxLength, range } from 'util/validation'

import { PrenatalPartoNascimentoModel } from './prenatal-parto-nascimento/PrenatalPartoNascimento'
import { PuericulturaModel } from './PuericulturaView'

export const puericulturaValidator = createValidator<PuericulturaModel>({
  prenatal: createValidator<PrenatalPartoNascimentoModel>(
    {
      apgarUm: [maxLength(2), range(0, 10)],
      apgarCinco: [maxLength(2), range(0, 10)],
      apgarDez: [maxLength(2), range(0, 10)],
      peso: [maxLength(7), range(0.5, 500)],
      comprimento: [maxLength(6), range(20, 250)],
      perimetroCefalico: [maxLength(5), range(10, 200)],
    },
    (formValues, errors) => {
      if (formValues) {
        if (!errors.idadeGestacional)
          errors.idadeGestacional =
            maxLength(2)(formValues.idadeGestacional?.semanas) && 'Semanas deve possuir no máximo 2 caracteres.'
        if (!errors.idadeGestacional)
          errors.idadeGestacional =
            range(20, 42)(formValues.idadeGestacional?.semanas) && 'Semanas deve ter valor entre 20 e 42.'

        if (!errors.idadeGestacional)
          errors.idadeGestacional =
            maxLength(1)(formValues.idadeGestacional?.dias) && 'Dias deve possuir no máximo 1 caracter.'
        if (!errors.idadeGestacional)
          errors.idadeGestacional = range(0, 6)(formValues.idadeGestacional?.dias) && 'Dias deve ter valor entre 0 e 6.'

        return errors
      }
    }
  ),
})
